import React, { useEffect, useState } from 'react';

import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';

import { RootState } from 'store/ducks';

import Text from 'components/Text';
import { Row, Column } from 'components/Layout/Grid';
import MenuItemsCustomer from 'components/MenuItemsCustomer';
import TabNavigation from 'components/TabNavigation';
import OrdersTable from 'components/Table/Orders';
import Loading from 'components/Loading';
import TicketsTable from 'components/Table/Tickets';
import { ticketsModelBasic } from 'components/Table/Tickets/models';
import Animated from 'components/Animated';
import QuotesTable from 'components/Table/Quotes';
import {
  ordersModelCompletePending,
  ordersItemsModelBilled,
  ordersModelCompleteButton,
  ordersModelCompleteButtonShipping,
} from 'components/Table/Orders/models';
import SwitchComponent from 'components/SwitchComponent';
import OrderDropdown from 'components/OrderDropdown';
import store from 'store';
import { ITableModel } from 'components/Table/interface';
import { Button } from 'components/Button';
import toast from 'components/Toast/dispatch';
import CustomerService from 'services/customer.service';
import {
  cotacoesAction,
  eventName,
  pedidosAction,
  protocolosAction
} from 'components/ApplicationInsights/eventNames';
import { DataCustomer } from 'components/DataCustomer';
import { LegalDocuments } from 'components/LegalDocuments';
import 'components/ModelButton/styles.scss';

import { OrdersTabsEnum } from 'models/Order';
import { EnumUserType } from 'models/User';

import Styles from './styles';

const Customer: React.FC = () => {
  const user = useSelector((state: RootState) => state.user);
  const customer = useSelector((state: RootState) => state.customer);
  const navigate = useNavigate();
  const [refreshCustomer, setRefreshCustomer] = useState(false);

  const [ticketFilter, setTicketFilter] = useState({
    statusType: { ne: 'DONE' },
  });

  const [tabFilter, setTabFilter] = useState();
  const [, setCurrentPage] = useState(0);
  const pageSize = 10;

  useEffect(() => {
    !customer?.companyName && navigate('/dashboard');

    return () => {
      dispatch({
        type: 'SET_VIEW_OPTIONS_DOWNLOAD_IN_LOT',
        value: false,
      });
    };
  }, []);

  const [refreshTable, setRefreshTable] = useState(false);
  const dispatch = useDispatch();

  const editButtonLabel: ITableModel = {
    label: 'Protocolo',
    key: 'protocolNumber',
    size: 130,
    maxSize: 130,
    Component: (data: any) => (
      <Button
        className="px-0"
        onClick={() =>
          store.dispatch({
            type: 'OPEN_CARD',
            data: {
              id: data.cardId,
              protocolNumber: data.protocolNumber,
              responsibleGroup: data.responsibleGroup,
              ticketDevolution: data.ticketDevolution || null,
              ticketId: data.id,
              ticketCorrectionLetter: data.ticketCorrectionLetter || null,
              ticketReason: data.ticketReason,
              state: { setRefreshTable },
            },
          })
        }
        width="auto"
      >
        <Text className="color-blue-gray" size={12}>
          {data.protocolNumber}
        </Text>
      </Button>
    ),
  };

  const ticketModelEdit: Array<ITableModel> = [
    editButtonLabel,
    ...ticketsModelBasic,
  ];

  const _customerService = new CustomerService();

  const refreshDataCustomer = async () => {
    setRefreshCustomer(true);

    await _customerService
      .update(customer?.id)
      .then((result: any) => {
        const { data } = result;

        if (data) {
          dispatch({ type: 'SET_CUSTOMER', data });
          setRefreshCustomer(false);
          toast.success('Dados atualizados com sucesso.');
        } else {
          setRefreshCustomer(false);
          toast.error('Não foi possível realizar a atualização dos dados. Favor tentar novamente mais tarde.');
        }

      })
      .catch(() => {
        setRefreshCustomer(false);
        toast.error('Não foi possível realizar a atualização dos dados. Favor tentar novamente mais tarde.');
      });
  };

  useEffect(() => {
    const element = document.body;

    element.classList.add('background-body-customer');
    return () => {
      element.classList.remove('background-body-customer');
    };
  }, []);

  return (
    <SwitchComponent
      roles={['administrator', 'member']}
      type={['employee']}
      redirect="/dashboard"
    >
      <Animated
        show={!customer?.companyName || refreshCustomer}
        animationIn="none"
        animationInDelay="faster"
        animationOut="fadeOut"
        animationOutDelay="delay-1s"
        className={`fixed top-0 right-0 bottom-0 left-0 d-flex align-center justify-center z-999 ${!customer?.companyName && !refreshCustomer && 'bg-white'}`}
      >
        <Loading size={45} />
      </Animated>
      {customer?.companyName && (
        <>
          <Styles.CustomerWrapper>
            <Row className="flex-1 flex-lg-column justify-between customer-header">
              <Row className="align-center flex-lg-column align-lg-none w-70 w-sm-100">
                <Text
                  size={36}
                  className="color-primary font-bold customer-header--name"
                >
                  {customer?.companyName}
                </Text>
                <Text
                  size={12}
                  className="ml-3 ml-sm-0 color-blue-gray font-italic text-wrap pr-1"
                >
                  Código Interno {customer?.identifier} {customer?.crmCustomerCode && '| Código Cliente '}{' '}
                  {customer?.crmCustomerCode}
                </Text>
              </Row>
            </Row>

            <Animated
              show
              animationIn="slideInUp"
              animationInDelay="faster"
              animationOut="none"
              animationOutDelay="faster"
            >
              <div
                className="bg-white mx-3 px-3 pb-3 customer-content"
                style={{ borderRadius: '10px 10px 0 0' }}
              >
                <div className="customer-content--buttons">
                  <MenuItemsCustomer />
                </div>
                <Row className="container-data-customer flex-1 flex-lg-column">
                  <DataCustomer customer={customer} refreshCustomer={refreshDataCustomer} />

                  <Column className="flex-lg-1 w-lg-100 pl-2 ml-lg-0 w-60 min-w-60">
                    <Text size={24} className="color-primary font-bold">
                      Protocolos
                    </Text>
                    <TabNavigation
                      trackingKey="Abas Protocolos"
                      trackingEvent={eventName.PROTOCOLOS}
                      className="mt-3"
                      setTabFilter={(filter) => setTicketFilter(filter)}
                      tabLabels={[
                        {
                          label: 'Abertos',
                          trackingName: protocolosAction.ABA_DASHBOARD_PROTOCOLOSABERTOS
                        },
                        {
                          label: 'Fechados',
                          trackingName: protocolosAction.ABA_DASHBOARD_PROTOCOLOSFECHADOS
                        },
                      ]}
                      pages={[
                        <TicketsTable
                          trackingKey="Protocolos Abertos"
                          pageSize={5}
                          tabFilter={ticketFilter}
                          showButton
                          model={ticketModelEdit}
                          completeBlankSpaces
                          showProtocolsOnLoad
                          refreshTable={refreshTable}
                          isPageTickets={false}
                          statusTypes={[0, 1]}
                        />,
                        <TicketsTable
                          trackingKey="Protocolos Fechados"
                          pageSize={5}
                          tabFilter={ticketFilter}
                          showButton
                          model={ticketModelEdit}
                          completeBlankSpaces
                          showProtocolsOnLoad
                          refreshTable={refreshTable}
                          isPageTickets={false}
                          statusTypes={[2]}
                        />,
                      ]}
                    />
                  </Column>
                </Row>
                <LegalDocuments legalDocumentsAttachments={customer.legalDocuments} />
              </div>
            </Animated>

          </Styles.CustomerWrapper>

          <Column className="mt-3">
            <TabNavigation
              trackingKey="Abas Pedidos"
              trackingEvent={eventName.PEDIDOS}
              setCurrentPage={setCurrentPage}
              setTabFilter={(filter) => setTabFilter(filter)}
              tabLabels={[
                { label: 'Pedidos Faturados', trackingName: pedidosAction.ABA_DASHBOARD_PEDIDOSFATURADOS },
                { label: 'Pedidos Pendentes', trackingName: pedidosAction.ABA_DASHBOARD_PEDIDOSPENDENTES },
                { label: 'Venda Triangular', trackingName: pedidosAction.ABA_DASHBOARD_VENDATRIANGULAR },
                { label: 'Cotações', filter: {}, trackingName: cotacoesAction.ABA_DASHBOARD_COTACOES },
              ]}

              pages={[
                <Column className="w-100 max-w-lg-100 flex-1">
                  <OrdersTable
                    trackingKey="Grid Pedidos Faturados"
                    showFilter
                    tabFilter={tabFilter}
                    DropdownTemplate={(data: any) => (
                      <OrderDropdown {...data} order={data} model={ordersItemsModelBilled} showDevolutionDownloadButtons />
                    )}
                    model={ordersModelCompleteButton(user)}
                    pageSize={pageSize}
                    showAdvancedFilters
                    viewFilters={{
                      showSituationFilter: true,
                      showEnterpriseFilter: true,
                      showSubsidiaryFilter: true
                    }}
                    showTypeDateFilter
                    showDownloadInLotButton={false}
                    //showExportButton={true}
                    showExportButton={false}
                    currentTabId={{
                      name: OrdersTabsEnum.PEDIDO_FATURADO,
                      order: 0
                    }}
                  />
                </Column>,
                <Column className="w-100 max-w-lg-100 flex-1">
                  <OrdersTable
                    trackingKey="Grid Pedidos Pendentes"
                    searchInputPlaceholder="Pedido, lote, ordem ou produto"
                    showFilter
                    tabFilter={tabFilter}
                    DropdownTemplate={(data: any) => (
                      <OrderDropdown {...data} order={data} />
                    )}
                    model={ordersModelCompletePending}
                    pageSize={pageSize}
                    viewFilters={{
                      showSituationFilter: true
                    }}
                    customProps={{ showOrderDownloadButtons: false }}
                    /*showExportButton={user?.userType === EnumUserType.EMPLOYEE}*/
                    showExportButton={false}
                    currentTabId={{
                      name: OrdersTabsEnum.PEDIDO_PENDENTE,
                      order: 1
                    }}
                  />
                </Column>,
                <Column className="w-100 max-w-lg-100 flex-1">
                  <OrdersTable
                    trackingKey="Grid Venda Triangular"
                    searchInputPlaceholder="Nº nota de remessa, nome paciente, ordem, produto"
                    showFilter
                    tabFilter={tabFilter}
                    DropdownTemplate={(data: any) => (
                      <OrderDropdown {...data} order={data} />
                    )}
                    model={ordersModelCompleteButtonShipping}
                    pageSize={pageSize}
                    showAdvancedFilters
                    viewFilters={{
                      showSituationFilter: true,
                      showEnterpriseFilter: true,
                      showSubsidiaryFilter: true
                    }}
                    customProps={{ showOrderDownloadButtons: false, showOrderDownloadShippingButtons: true }}
                    showExportButton={false}
                    currentTabId={{
                      name: OrdersTabsEnum.VENDA_TRIANGULAR,
                      order: 2
                    }}
                  />
                </Column>,
                <QuotesTable
                  trackingKey="Grid Cotações"
                  showFilter
                  pageSize={pageSize}
                  /*showExportButton={user?.userType === 'employee'}*/
                  showExportButton={false}
                />,
              ]}
            />
          </Column>
        </>
      )}
    </SwitchComponent>
  );
};

export default Customer;